<template>
  <v-dialog :value="showDialog" max-width="600" persistent @keydown.esc="$emit('close')">
    <v-card class="pa-4">
      <div class="d-flex align-center justify-space-between mb-4">
        <h2 class="mb-0">Editar Criticidade</h2>
        <v-btn icon small @click="$emit('close')" color="#707070">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-row class="ma-0" dense>
        <v-col cols="12">
          <label class="label">Setor</label>
          <v-text-field
            v-model="form.departmentName"
            outlined
            disabled
            class="primary-input"
          ></v-text-field>
        </v-col>

        <v-col cols="12">
          <label class="label">Sub-setor</label>
          <v-text-field
            v-model="form.subDepartmentName"
            outlined
            disabled
            class="primary-input"
          ></v-text-field>
        </v-col>

        <v-col cols="12">
          <label class="label">Oficina</label>
          <v-text-field
            v-model="form.workshopName"
            outlined
            disabled
            class="primary-input"
          ></v-text-field>
        </v-col>

        <v-col cols="12">
          <label class="label">Criticidade</label>
          <v-select
            v-model.number="form.urgencyLevel"
            :items="urgencyLevels"
            outlined
            hide-details="auto"
            class="primary-input"
            item-text="label"
            item-value="value"
            :error="fieldErrors.urgencyLevel && ![0, 1, 2].includes(form.urgencyLevel)"
            :error-messages="fieldErrors.urgencyLevel && ![0, 1, 2].includes(form.urgencyLevel) ? ['Campo obrigatório'] : []"
          ></v-select>
        </v-col>
      </v-row>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn
          dark
          depressed
          @click="$emit('close')"
          class="quaternary-button ma-1"
          color="#FF4F64"
        >
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn class="secondary-button" depressed :loading="saveLoading" @click="$emit('save')">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EditCriticalityDialog',
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    fieldErrors: {
      type: Object,
      default: () => ({}),
    },
    urgencyLevels: {
      type: Array,
      default: () => [],
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
